import { axiosEduServer } from "../utils/configAxios";

export const crearModalidad = (data) => {
  return axiosEduServer.post('/modalidad', data).then(({ data }) => data).catch((err) => { throw err });
};

export const actualizarModalidad = (id, data) => {
  return axiosEduServer.put(`/modalidad/${id}`, data).then(({ data }) => data).catch((err) => { throw err });
};

export const eliminarModalidad = (id) => {
  return axiosEduServer.delete(`/modalidad/${id}`).then(({ data }) => data).catch((err) => { throw err });
};

export const getOneModalidad = (id) => {
  return axiosEduServer.get(`/modalidad/${id}`).then(({ data }) => data).catch((err) => { throw err });
};

export const getAllModalidades = () => {
  return axiosEduServer.get('/modalidad').then(({ data }) => data).catch((err) => { ; throw err });
};